const VAGALUME_SESSIONS_KEY = 'vagalume-sessions-tulum';
const MYSTICAL_KEY = 'mystical-sunset-tulum';
const SUMMERIANS_KEY = 'summerians-ibiza-tulum';
const RITMIC_KEY = 'ritmic-vagalume-tulum';
const SOS_KEY = 'sos-save-our-souls-tulum';
const SINNER_KEY = 'sinner-tulum';
const SUNDAZE_KEY = 'sundaze-vagalume-tulum';
const PIKNIK_KEY = 'piknik-tulum';
const SET_UNDERGROUND_KEY = 'set-underground-tulum';
const GYPSY_DISCO_KEY = 'gypsy-disco-gitano-tulum';
const ANCESTRAL_SOUL_KEY = 'ancestral-soul-tulum';
const TEN_IBIZA_KEY = 'ten-ibiza-tulum';
const ANTS_KEY = 'ants-tulum';
const AFTERLIFE_KEY = 'afterlife-tulum';
const CIRCOLOCO_KEY = 'circoloco-tulum';
const CORE_KEY = 'core-tulum';
const KEINEMUSIK_KEY = 'keinemusik-tulum';
const ZAMNA_ON_THE_BEACH_KEY = 'zamna-on-the-beach';
const ZAMNA_TULUM_KEY = 'zamna-tulum';
const DAY_ZERO_KEY = 'day-zero-tulum';
const TEHMPLO_KEY = 'tehmplo-tulum';
const DPM_GLOBAL_KEY = 'dpm-global-tulum';



function brandDecoder(title) {
  if (!title) {
    return { title: '' };
  }
  let brand = title.split('@')[0].split("|")[1] || ''
  const brandMatch = brand.toLowerCase();
  const brandConfigMap = {
    'vagalume sessions': VAGALUME_SESSIONS_KEY,
    mystical: MYSTICAL_KEY,
    summerians: SUMMERIANS_KEY,
    ritmic: RITMIC_KEY,
    sos: SOS_KEY,
    sinner: SINNER_KEY,
    sundaze: SUNDAZE_KEY,
    piknik: PIKNIK_KEY,
    'underground': SET_UNDERGROUND_KEY,
    'gypsy disco': GYPSY_DISCO_KEY,
    ancestral: ANCESTRAL_SOUL_KEY,
    'ten.+?ibiza': TEN_IBIZA_KEY,      // Use regex
    'ants.+?tulum': ANTS_KEY,          // Use regex
    afterlife: AFTERLIFE_KEY,
    circoloco: CIRCOLOCO_KEY,
    'core.+?tomorrowland': CORE_KEY,  // Use regex
    keinemusik: KEINEMUSIK_KEY,
    'zamna.+?beach': ZAMNA_ON_THE_BEACH_KEY, // Use regex
    'zamna.+tulum': ZAMNA_TULUM_KEY,      // Use regex
    'day.+?zero': DAY_ZERO_KEY,        // Use regex
    tehmplo: TEHMPLO_KEY,
    dpm: DPM_GLOBAL_KEY
  };

  for (const key in brandConfigMap) {
    if (brandMatch.match(key)) {
      return {name: brandMatch, slug: brandConfigMap[key] }; // Consistent return
    }
  }
  return { name: '' }; // Consistent return
}

export { brandDecoder};
